import { createContext, useContext } from "react";

/**
 * Holds the Teams SSO token (or null when running outside Teams or before the
 * token has been acquired). Components that make API calls can read this
 * context instead of receiving the token through props.
 */
export const TeamsTokenContext = createContext<string | null>(null);

export function useTeamsToken(): string | null {
  return useContext(TeamsTokenContext);
}
